import { render, staticRenderFns } from "./LoadInventory.vue?vue&type=template&id=36e50544&scoped=true&"
import script from "./LoadInventory.vue?vue&type=script&lang=js&"
export * from "./LoadInventory.vue?vue&type=script&lang=js&"
import style0 from "./LoadInventory.vue?vue&type=style&index=0&id=36e50544&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e50544",
  null
  
)

export default component.exports